import { z } from 'zod';
import { TenantIdSchema, IsoDateSchema, MoneySchema } from './_primitives.js';

export const SHIPMENT_STATUS = Object.freeze({
  DRAFT:       'draft',
  BOOKED:      'booked',
  IN_TRANSIT:  'in_transit',
  DELIVERED:   'delivered',
  EXCEPTION:   'exception',
  CANCELLED:   'cancelled',
});

export const ShipmentStatusEnum = z.enum(Object.values(SHIPMENT_STATUS));

export const ShipmentSchema = z.object({
  tenantId:       TenantIdSchema,
  id:             z.string().optional(),
  shipmentNumber: z.string().optional(),
  status:         ShipmentStatusEnum,
  orderId:        z.string().optional(),
  customerId:     z.string().optional(),
  carrierId:      z.string().optional(),
  originAddress:  z.string().optional(),
  destAddress:    z.string().optional(),
  scheduledPickup:IsoDateSchema.optional(),
  scheduledDelivery: IsoDateSchema.optional(),
  actualPickup:   IsoDateSchema.optional(),
  actualDelivery: IsoDateSchema.optional(),
  cost:           MoneySchema.optional(),
  isDeleted:      z.boolean().optional(),
  createdAt:      z.union([IsoDateSchema, z.object({})]).optional(),
  updatedAt:      z.union([IsoDateSchema, z.object({})]).optional(),
  version:        z.number().int().optional(),
}).passthrough();

/** @typedef {import('zod').infer<typeof ShipmentSchema>} Shipment */
